import { BaseSearchModel } from "../../query/base-search.model";

export class UserSearchModel extends BaseSearchModel {
    name?: string;
    lastName?: string;
    userName?: string;
    userId?: string;
    socialId?: string;
    businessUnitId?: string;
    email?: string;
    createdById?: string; 
    status?: any;
    isEnabled?: boolean;
    tenantId?: string;

    fullName?: string;
}